import Order from '@components/order';
import { OrdersContext } from '@contexts/OrdersContext';
import { Box } from '@mui/material';
import React, { useContext } from 'react';
import OrdersTitle from './OrdersTitle';
import { Typography, IconButton } from '@elements';
import PrevIcon from '@images/prev.svg';
import NextIcon from '@images/next.svg';
import { Icon } from '@elements';

type Props = {
  consistType: string;
};

const Orders = ({ consistType }: Props) => {
  const ordersContext = useContext(OrdersContext);

  if (!ordersContext || !ordersContext.data) {
    return null;
  }

  const { data, pageNumber, setPageNumber } = ordersContext;
  const orders = data.content || [];

  const hasNextPage = data.totalPages > 0 && pageNumber < data.totalPages - 1;
  const hasPrevPage = pageNumber > 0;

  const handleNextPage = () => {
    if (hasNextPage) {
      setPageNumber(pageNumber + 1);
    }
  };

  const handlePrevPage = () => {
    if (hasPrevPage) {
      setPageNumber(pageNumber - 1);
    }
  };

  if (orders.length === 0) {
    return (
      <Box>
        <OrdersTitle
          total={data.total ?? 0}
          pageNumber={pageNumber}
          totalPages={data.totalPages}
        />
        <Typography>Ничего не найдено</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <OrdersTitle
        total={data.total ?? 0}
        pageNumber={pageNumber}
        totalPages={data.totalPages}
      />
      {orders.map((order) => (
        <Order key={order.uuid} order={order} />
      ))}
      {data.totalPages > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
            mt: '24px',
            mb: '24px',
          }}
        >
          <IconButton
            onClick={handlePrevPage}
            disabled={!hasPrevPage}
            sx={{
              opacity: hasPrevPage ? 1 : 0.5,
              cursor: hasPrevPage ? 'pointer' : 'not-allowed',
            }}
          >
            <Icon src={PrevIcon} width={24} height={24} />
          </IconButton>
          <Typography>
            {pageNumber + 1} / {data.totalPages}
          </Typography>
          <IconButton
            onClick={handleNextPage}
            disabled={!hasNextPage}
            sx={{
              opacity: hasNextPage ? 1 : 0.5,
              cursor: hasNextPage ? 'pointer' : 'not-allowed',
            }}
          >
            <Icon src={NextIcon} width={24} height={24} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default Orders;
